/* eslint-disable react/prop-types */
import { Dialog, DialogContent } from "@mui/material";
import CircularProgressWithLabel from "./circularProgressWithLabel";

function DialogProgress({ open, value }) {
  return (
    <Dialog open={open} hideBackdrop>
      <DialogContent>
        <CircularProgressWithLabel
          value={value}
          size={"8rem"}
          sx={{ m: "1rem" }}
        />
      </DialogContent>
    </Dialog>
  );
}

export default DialogProgress;
